import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";

const defaultDateString = dayjs().format("DD/MM/YYYY");
const defaultDate = dayjs().format("YYYY-MM-DD");

export const getCpdCourseForm = () => {
	return {
		id: uuidv4(),
		formId: 0,
		formTypeId: 9,
		title: "New Course Claim - " + defaultDateString,
		startDate: defaultDate,
		endDate: "9999-12-31",
		statusId: 1,
		personId: null, //auto set by backend
		businessUnitId: 0,
		companyId: 0,
		courseName: null,
		courseDetails: null,
		courseLocation: null,
		leaveComments: null,
		courseIsOverseas: null,
		courseCountryLookupId: null,
		submitIsSupportingDocumentsAttached: null,
		submitIsNZDGST: null,
		isPersonConsentGiven: null,
		isDeleted: false,
	};
};
export const getCpeForm = () => {
	return {
		id: uuidv4(),
		formId: 0,
		formTypeId: 1,
		title: "New Course Request - " + defaultDateString,
		startDate: defaultDate,
		endDate: "9999-12-31",
		statusId: 1,
		personId: null, //auto set by backend
		businessUnitId: 0,
		companyId: 0,
		courseName: null,
		courseDetails: null,
		courseLocation: null,
		leaveComments: null,
		courseIsOverseas: null,
		courseCountryLookupId: null,
		submitIsSupportingDocumentsAttached: null,
		submitIsNZDGST: null,
		isPersonConsentGiven: null,
		isDeleted: false,
	};
};

export const validateCpeForm = createAsyncThunk(
	"cpeForm/validateCpeForm",
	async (_, { dispatch, getState }) => {
		const state = getState();
		const {
			courseName,
			courseIsOverseas,
			courseCountryLookupId,
			isAnnualLeave,
			annualLeaveDates,
		} = selectCpeFormData(state);
		let errors = [];
		if (!courseName) errors.push("Course name is required");
		if (courseIsOverseas && !courseCountryLookupId)
			errors.push("Country is required if course is overseas");
		if (isAnnualLeave === null || isAnnualLeave === undefined) {
			errors.push("Annual leave plan is required");
		}
		if (isAnnualLeave && !annualLeaveDates) {
			errors.push("Annual leave dates are required");
		}
		dispatch(validationErrorsEdited(errors.length));
		dispatch(validationErrorListEdited(errors));
		return errors.length;
	}
);

const initialState = {
	error: null,
	data: {
		...getCpeForm(),
	},
	validationErrors: 0,
	validationErrorList: [],
};

const cpeFormSlice = createSlice({
	name: "cpeForm",
	initialState,
	reducers: {
		cpeFormReceived(state, action) {
			state.data = action.payload;
		},
		cpeFormEdited(state, action) {
			const { id, value } = action.payload;
			state.data[id] = value;
			if (id === "courseName") {
				state.data.title = `${value} - ${dayjs(state.startDate).format(
					"DD/MM/YYYY"
				)}`;
			}
		},
		validationErrorsEdited(state, action) {
			state.validationErrors = action.payload;
		},
		validationErrorListEdited(state, action) {
			state.validationErrorList = action.payload;
		},
	},
	extraReducers: {
		RESET_CME: (state, action) => {
			return initialState;
		},
	},
});

export const {
	cpeFormEdited,
	cpeFormReceived,
	validationErrorsEdited,
	validationErrorListEdited,
} = cpeFormSlice.actions;

export const selectCpeFormData = (state) => state.cme.cpeForm.data;
export const selectCpeFormId = (state) => state.cme.cpeForm.data.formId;
export const selectCpeFormLeaveComments = (state) =>
	state.cme.cpeForm.data.leaveComments;
export const selectCpeFormValidationErrorList = (state) =>
	state.cme.cpeForm.validationErrorList;

export default cpeFormSlice.reducer;
